'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useEffect, useRef, useState} from 'react';
// @ts-ignore
import {AdyenCheckout, Card, PersonalDetails} from '@adyen/adyen-web';
import cn from 'classnames';
import etask from 'zetask';
import _ from 'zutil';
import zurl from 'zurl';
import zutil from '/util/util.js';
import csrf from '/util/csrf.js';
import plus_util from '/www/hola/pub/plus_util.js';
import modal from '/www/hola/pub/modal.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import string from '/util/string.js';
import {t_premium_page_opt} from '../premium/use_premium_page';
import {use_qs} from '../../lib/use_qs';
import styles from './cc_adyen.module.less';
// @ts-ignore
import {get_price_plan} from '../../../../../svc/account/pub/membership';
import {i_plan} from '../../plus/plus_types';

const {qw} = string;

type t_payment_form_props = {
    get_email: (email: string, user: any)=>string;
    set_email: (email: string)=>void;
    before_payment?: ()=>void;
    after_payment?: ()=>void;
    on_submit_error?: (resp: any)=>void;
    set_fallback_route?: ()=>void;
    on_payment?: (resp: any)=>void;
    submit_payment?: (type: string, opt: any)=>void;
};

type t_cc_adyen_props = t_payment_form_props & t_premium_page_opt & {
    session_flow?: boolean;
    on_load?: ()=>void;
    show: boolean;
    Skeleton_comp?: React.FC<{abs?: boolean}>
    with_skeleton?: boolean;
};

export const CC_adyen = (props: t_cc_adyen_props)=>{
    const {on_load, show, with_skeleton, Skeleton_comp} = props;
    const {user, plan, currency, country} = props;
    const {price} = get_price_plan(plan, currency);
    // We change key on component to force
    // complete remounting of component when
    // component's props changes to clean DOM for UI-lib
    const key = `${country}_${currency}_${price}`;
    const params = {key, country, currency, price, plan, show, user,
        with_skeleton, Skeleton_comp, submit_payment, form: props};
    useEffect(()=>{
        if (on_load)
            on_load();
    }, []);
    return <CC_adyen_adv {...params} />;
};

type t_cc_adyen_internal_props = {
    price: number, plan: i_plan; show: boolean;
    form: t_cc_adyen_props,
    Skeleton_comp?: React.FC<{abs?: boolean}>; with_skeleton?: boolean
} & Pick<t_premium_page_opt, 'country' | 'currency' | 'user'>;

// Same as in plus_ui. Merge to there when out of WIP
const get_email = (email, user)=>{
    email = _.get(user, 'emails.0.value') || email;
    if (!email)
    {
        const el: any = document.querySelector('.email_field [name="email"]');
        email = el && el.value;
    }
    return (email||'').trim().toLowerCase();
};

const after_payment = (dropin, resp, form)=>etask(function*(){
    const status = resp.resultCode == 'Authorised' ? 'success' : 'error';
    dropin.setStatus(status);
    plus_util.perr({id: 'www_premium_payment_submit_adyen',
        info: {hola_uid: resp.hola_uid, hola_plan_id: resp.hola_plan_id}});
    if (form?.after_payment)
        yield form.after_payment(resp);
    if (status == 'success' && resp.back_url)
    {
        location.href = (resp.back_url.includes('//') ? '' : '//')
            + resp.back_url;
    }
});

const on_err = err=>console.error(err);

const submit_payment = (type, opt, form: t_cc_adyen_props)=>{
    const {dropin} = opt, {user} = form;
    opt = zutil.omit(opt, 'dropin');
    plus_util.perr({id: 'www_premium_payment_submit_clicked_adyen',
        info: {hola_uid: user?.hola_uid, period: opt.plan.period,
            hola_plan_id: opt.plan.id}});
    const _opt = {
        on_err,
        email: opt.shopperEmail,
        after_payment: resp=>after_payment(dropin, resp, form),
    };
    for (const k in opt)
        zutil.if_set(opt[k], _opt, k);
    if (form?.submit_payment)
        return form.submit_payment(type, _opt);
    return plus_util.payment_api(type, _opt);
};

const process_redirect = (info, state, resp, actions)=>etask(function*(){
    const {action} = resp;
    const popup = modal.open_remote_modal({
        form: action,
        url: 'about:blank',
        no_bg_close: true,
        no_kb_close: true,
        on_cancel: ()=>{
            this.throw({pub_reason: '3D Secure cancelled'});
        }
    });
    (window as any).adyen_3ds_cb = success=>{
        popup.close();
        if (!success)
            this.throw({pub_reason: '3D Secure failed'});
        // E.perr({id: 'www_premium_payment_adyen_3ds_success', info});
        actions?.resolve(resp);
        this.return(resp);
    };
    return yield this.wait();
});

type t_info = {
    country_code: string;
    currency: string;
    env: 'test' | 'live';
    plan: i_plan;
    price: number;
}

const adv_process_info = data=>{
    if (Object.keys(data.details).length && !data.details.isValid)
        throw new Error(`Details invalid: ${data.details.errors}`);
    const info = zutil.omit(data, ['details', 'country']);
    info.country_code = info.country_code||data.country;
    for (let key in data.details.data)
        info[key] = data.details.data[key];
    return info;
};

const adv_make_payment = (info: t_info, form: t_cc_adyen_props,
    state, dropin, actions, set_error)=>etask(function*(){
    this.on('uncaught', e=>{
        console.error(e);
        actions.reject();
    });
    let resp = null;
    const on_payment_error = (error_msg: string, e?: unknown)=>{
        set_error(error_msg, dropin);
        if (form.on_submit_error)
            return form?.on_submit_error(resp);
        plus_util.perr({id: 'www_premium_payment_submit_failed_adyen',
            error_msg,
            exception: String(e),
            info: {
                hola_uid: resp?.hola_uid,
                hola_plan_id: resp?.hola_plan_id}});
    };
    try {
        set_error('');
        resp = yield submit_payment('adyen', {...info, state, dropin}, form);
        if (!resp?.resultCode)
        {
            on_payment_error('Network error');
            return actions.reject();
        }
        const {action} = resp;
        if (0 && action?.type == 'redirect')
            return yield process_redirect(info, state, resp, actions);
        if (resp.refusalReason)
            set_error(resp.refusalReason, dropin);
        form?.on_payment && form.on_payment(resp);
        actions.resolve(resp);
    } catch(e){
        console.error(e);
        on_payment_error('Network error', e);
        actions.reject();
        throw e;
    }
});

const adv_additional_details = (info, form, state, dropin, actions)=>
etask(function*(){
    this.on('uncaught', e=>{
        console.error(e);
        actions.reject();
    });
    // const {data} = state;
    const resp = yield fetch('/users/payment/adyen_make_details', {
        method: 'POST', json: true, body: {info, state}});
    if (!resp.resultCode)
    {
        actions.reject();
        form?.on_submit_error(resp);
    }
    form?.on_payment && form.on_payment(resp);
    actions.resolve(zutil.pick(resp, ...qw`resultCode action
        order donationToken`));
    return yield after_payment(dropin, resp, form);
});

const adyen_error = (form: t_cc_adyen_props, err)=>{
    console.error(err);
    // @ts-ignore
    const errors = window.global_adyen_errors = window.global_adyen_errors||[];
    // Ignore same error
    if (err instanceof Error && errors.includes(err))
        return;
    errors.push(err);
    if (errors.length>2 && form?.set_fallback_route)
        form.set_fallback_route();
};

const CC_adyen_adv =
({currency, country, price, plan, user, show,
    form, Skeleton_comp, with_skeleton}: t_cc_adyen_internal_props)=>{
    const ref_dropin = useRef<HTMLDivElement>();
    const ref_email = useRef<HTMLDivElement>();
    const [inited, set_inited] = useState(false);
    const [error, set_error_state] = useState('');
    const set_error = (err_line, dropin)=>{
        if (err_line)
            adyen_error(form, err_line);
        if (dropin && err_line)
            dropin.setStatus('error');
        set_error_state(err_line);
    };
    const email = form?.get_email && form.get_email(form?.email, user)
        || get_email(form?.email, user);
    const force_test_env = Boolean(use_qs().test);
    useEffect(()=>{
        etask(function*(){
            try {
                let details = {};
                const details_change = state=>details = state;
                const args: {csrf_token: string, test_env?: number} =
                    {csrf_token: csrf.get()};
                if (force_test_env)
                    args.test_env = 1;
                const creds = yield fetch(`/users/payment/adyen_creds?${
                    zurl.qs_str(args)}`, {json: true});
                country = country||creds.country;
                const info_fn = ()=>adv_process_info({country, plan, price,
                    currency, details, ...zutil.pick(creds, qw`env token`)});
                const methods = yield fetch(
                    '/users/payment/adyen_payment_methods', {method: 'POST',
                        json: true, body: {info: info_fn()}});
                if (methods.error)
                    throw new Error(`err_get_payments: ${methods.error}`);
                if (!methods.paymentMethods)
                    throw new Error(`err_get_payments: no payment methods`);
                const config = {
                    environment: creds.env,
                    paymentMethodsResponse: methods,
                    clientKey: creds.client_key,
                    countryCode: country,
                    locale: 'en-US',
                    analytics: {enabled: false},
                };
                const cardConfig = {
                    hasHolderName: true,
                    holderNameRequired: true,
                    billingAddressRequired: false,
                    enableStoreDetails: false,
                    challengeWindowSize: '05' as const,
                    onError: err=>{
                        adyen_error(form, err);
                        if (form?.on_submit_error)
                            form.on_submit_error(err);
                    },
                    onSubmit: (state, dropin, actions)=>adv_make_payment(
                        info_fn(), form, state, dropin, actions, set_error),
                    onAdditionalDetails: (state, dropin, actions)=>
                        adv_additional_details(info_fn(), form, state,
                            dropin, actions)
                };
                const checkout = yield AdyenCheckout(config);
                new Card(checkout, cardConfig).mount(ref_dropin.current);
                if (!email)
                {
                    new PersonalDetails(checkout, {
                            requiredFields: ['shopperEmail'],
                            onChange: details_change,
                    } as any).mount(ref_email.current);
                }
                set_inited(true);
            } catch(e){
                adyen_error(form, e);
                if (form?.on_submit_error)
                    form.on_submit_error(e);
            }
        });
    }, []);

    return <div className={cn(styles.adyen, !show && styles.hidden)}>
      {!email && <div key="div_details" ref={ref_email} />}
      <div key="div_dropin" ref={ref_dropin} />
      {!inited && with_skeleton && <Skeleton_comp abs/>}
      {!!error && <div className="alert-danger alert">{error}</div>}
    </div>;
};
